module.exports = __webpack_public_path__ + "img/s00133.a8c79d74.png";